import BookingHistoryList from './BookingHistoryList';
export default BookingHistoryList;
